import { Button, Col, Form, Input, message, Modal, Row } from 'antd';
import React from "react";
import { raiseSupportTicketAPI } from '../../services/ticketing-service';
const { TextArea } = Input;
class CreateTicketForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ticket: {
                subject: '',
                description: '',
            },
            submitting: false

        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                this.setState({ submitting: true });
                let response = await raiseSupportTicketAPI(values);
                if (response.success) {
                    message.success('Ticket raised successfully');
                    this.props.handleCreateTicket();
                } else {
                    message.error('Failed to raise ticket!');
                }
                this.setState({ submitting: false });
            }
        });
    };

    render() {
        const { visible, onOk, onCancel } = this.props;
        const { getFieldDecorator } = this.props.form;
        return (
            <Modal
                title="Raise Ticket"
                visible={visible}
                onCancel={onCancel}
                footer={null}
                width={480}
                style={{ top: 15 }}
            >
                <div className="container-alike">
                    <Row>
                        <Col span={24}>
                            <Form
                                layout='vertical'
                            >
                                <Form.Item label="Subject">
                                    {getFieldDecorator('subject', {
                                        initialValue: this.state.subject,
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Please input ticket subject!',
                                            }
                                        ],
                                    })(<Input />)}
                                </Form.Item>
                                <Form.Item label="Ticket Description">
                                    {getFieldDecorator('description', {
                                        initialValue: "",
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Please input ticket description!',
                                            },
                                        ],
                                    })(<TextArea style={{ height: 70 }} />)}
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </div>
                <div style={{ marginTop: "-8px", marginBottom: "15px" }}>
                    <span style={{ fontSize: "10px", fontStyle: "italic" }}>Note: Please provide your contact details in ticket description. Thank you.</span>
                </div>
                <div className="custom-footer">
                    <div>
                        <Button loading={this.state.submitting} onClick={this.handleSubmit}>
                            Submit Ticket
                        </Button>
                        <Button key="back" onClick={onCancel}>
                            Cancel
                        </Button>
                    </div>
                </div>
            </Modal >
        );
    };
}

const CreateTicketModal = Form.create({ name: 'edit-event-info' })(CreateTicketForm);

export default CreateTicketModal;